import { render, staticRenderFns } from "./ProductPickerDialog.vue?vue&type=template&id=5a7c2b7b&"
import script from "./ProductPickerDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductPickerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPickerDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports